<template>
  <Popup style="background-color: rgba(0, 0, 0, 0);" v-model:show="show" position="bottom">
    <div class="select">
      <div class="select__bar">
        <div class="select__cancel" @click="close">取消</div>
        <div class="select__title">选择用车周期</div>
        <div class="select__submit" @click="confirm">确定</div>
      </div>
      <div class="select__picker" v-if="showPicker">
        <Picker :columns="columns" :default-index="defaultIndex" :show-toolbar="false" @change="changeHandler" />
      </div>

    </div>
  </Popup>
</template>
<script setup>
import { Popup, Picker } from 'vant';
import { ref } from "vue";
const defaultIndex = ref(0)
const showPicker = ref(true)
const columns = ref([
  ...Array.from({ length: 12 }).map((v, i) => `${1 + i}个月`),
  '一年以上'
])
const props = defineProps({
  selectPeriodStr: {
    type: String,
    default: ''
  },
})
const emit = defineEmits(['ok'])
const show = ref(false)

const changeHandler = (e) => {
  const index = columns.value.findIndex(v => v == e)
  defaultIndex.value = index
}
const open = () => {
  showPicker.value = false
  setTimeout(() => {
    const index = columns.value.findIndex(v => v == props.selectPeriodStr)
    if (~index) {
      defaultIndex.value = index
    } else {
      defaultIndex.value = 0
    }
    showPicker.value = true
    show.value = true
  }, 0)
}
const close = () => {
  show.value = false
}
const confirm = () => {
  emit('ok', columns.value[defaultIndex.value])
  close()
}
defineExpose({
  open,
  close,
})
</script>
<style lang="scss" scoped>
.select {
  background-color: #fff;
  width: 100%;
  padding-bottom: env(safe-area-inset-bottom);
}

.select__bar {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 34px;
  color: #232323;
  padding: 40px 40px 16px;
  justify-content: space-between;

  &::after {
    content: '';
    height: 1px;
    background: #dedede;
    position: absolute;
    bottom: 0;
    left: 40px;
    right: 40px;
    transform: scale(1, 0.5);
  }
}

.select__title {
  color: #8E9496;
  font-size: 30px;
  text-align: center;
}

::v-deep .van-hairline-unset--top-bottom.van-picker__frame {
  display: none;
}

::v-deep .van-picker__mask {
  background-image: linear-gradient(180deg, rgba(255, 255, 255, .8), rgba(255, 255, 255, .8)), linear-gradient(0deg, rgba(255, 255, 255, .8), rgba(255, 255, 255, .8));
}

::v-deep .van-picker-column__item {
  font-size: 38px;
  font-weight: 500;
}
</style>